import { ReactElement } from 'react';
import { TEMP_DATA_ROLES } from '../constants/temporary-data.constants';
import RoleSection from './RoleSection';
import AccessColorBlock from './AccessColorBlock';

/**
 * RolesTab management Page.
 * @returns - A Roles Tab management component.
 */
export default function RolesTab(): ReactElement {
  return (
    <div className="bg-container-500 flex my-4 flex-col">
      <div className="flex w-full justify-end p-4 h-fit">
        <div className="flex gap-20 flex-row">
          <AccessColorBlock withLabel accessLevel="full" />
          <AccessColorBlock withLabel accessLevel="view" />
          <AccessColorBlock withLabel accessLevel="none" />
        </div>
      </div>
      <div className="flex rounded overflow-hidden">
        <table className="w-full rounded divide-y divide-gray-900">
          <thead className="bg-container-900 text-xs text-gray-400 font-medium">
            <tr className="divide-x divide-gray-900 sticky top-0">
              <th className="py-3 px-6 text-start">
                <div className="flex items-center gap-1">
                  <div>Sections </div>
                  <div className="material-icons-outlined text-sm">arrow_downward</div>
                </div>
              </th>
              <th className="py-3 text-center">Owner</th>
              <th className="py-3 text-center">Administrator</th>
              <th className="py-3 text-center">User</th>
              <th className="py-3 text-center">Observer</th>
            </tr>
          </thead>
          {TEMP_DATA_ROLES.map((item) => {
            return <RoleSection key={item.type} data={item} />;
          })}
        </table>
      </div>
    </div>
  );
}
